// extracted by mini-css-extract-plugin
export default {"text":"HomeText_text__4c81N","link":"HomeText_link__ew3v+","links":"HomeText_links__t7qEo","textimg":"HomeText_textimg__32Kod"};